import { BENTOBOX_UPDATE_MARKETING_CONSENT_ENDPOINT } from 'reservations/base/constants/endpoints';
import { buildBentoboxApiEndpoint } from 'reservations/base/helpers/buildBentoboxApiEndpoint';
import type { Booking } from 'reservations/booking/types';
import { restClient } from 'utility/restClient';

async function updateMarketingConsent(booking: Booking) {
  const { phone, phoneCode, optInMarketingEmail, optInMarketingSms } = booking;
  const endpoint = buildBentoboxApiEndpoint(
    BENTOBOX_UPDATE_MARKETING_CONSENT_ENDPOINT
  );

  try {
    return await restClient.put(endpoint, {
      data: {
        phone: `+${phoneCode}${phone}`,
        subscribed_to_marketing_emails: optInMarketingEmail,
        subscribed_to_marketing_sms: optInMarketingSms
      }
    });
  } catch (e) {
    console.warn(
      `[updateMarketingConsent] Request to ${endpoint} failed: "${e}"`
    );
  }
}

export { updateMarketingConsent };
